<template>
    <div class="tabs" :class="rootClasses" role="tablist">
        <div class="tabs--panel">
            <ul class="u-reset tabs--headers" role="tablist">
                <li class="tabs--header" v-for="(item, itemIdx) in items" role="presentation">
                    <button class="btn btn__small" :class="buttonClasses"
                            @click.prevent="onRequestChange(itemIdx)"
                            :data-active="state.idx === itemIdx"
                            :role="'tab'"
                            :id="ariaUid('header', itemIdx)"
                            :aria-controls="ariaUid('panel', itemIdx)"
                            :aria-selected="state.idx === itemIdx">
                        <slot name="head" :item="item">
                            <!-- fallback content -->
                        </slot>
                    </button>
                </li>
            </ul>
        </div>

        <transition-group class="tabs--body" tag="div" name="trs-tabs-change">
            <div v-for="(item, itemIdx) in items" :key="itemIdx"
                    v-show="state.idx === itemIdx"
                    class="tabs--body-content"
                    role="tabpanel"
                    :id="ariaUid('panel', itemIdx)"
                    :aria-labelledby="ariaUid('header', itemIdx)">
                <slot name="body" :item="item">
                    <!-- fallback content -->
                </slot>
            </div>
        </transition-group>
    </div>
</template>

<script>
    import bemMixin from 'vue/mixins/bem';
    import ariaMixin from 'vue/mixins/aria';
    import uiPatternMixin from 'vue/mixins/ui-pattern';


    export default {
        mixins: [
            bemMixin('tabs'),
            ariaMixin('tabs'),
            uiPatternMixin('idx'),
        ],
        props: {
            items: {
                type: Array,
                required: true,
            },
            idx: {
                type: Number,
                default: 0,
            },
        },
        computed: {
            rootClasses() {
                return [
                    this.bemFacet,
                ];
            },
            buttonClasses() {
                return [
                    `btn__tabs-${ this.facet || 'base' }`,
                ];
            },
        },
    };
</script>



// WEBPACK FOOTER //
// index.vue?5f49be69